import { Box, Text } from '@streamelements/frontend-ui';

export function PendingOBSApi() {
  return (
    <Box css={{ size: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Text.Body>Awaiting 👍 from OBS...</Text.Body>
    </Box>
  );
}
